import { Grid2 as Grid } from "@mui/material";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";

export function CategoryForm() {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="name"
          label={translate("category_admin.fields.name")}
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="icon"
          label={translate("category_admin.fields.icon")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="order"
          label={translate("category_admin.fields.order")}
        />
      </Grid>
    </Grid>

  )
}
